const fichaAviso = {
  calculadoraSalario: {
    modal: {
      impuestos: ' el seguro social y el impuesto sobre la renta.',
    },
  },
}

export default fichaAviso
